import { throttle } from 'lodash';
import { breakpoints } from '@/constants';

export default {
  data() {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
    };
  },

  computed: {
    isGtMobile() {
      return !this.isMobile;
    },

    isGtTablet() {
      return !this.isMobile && !this.isTablet;
    },
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    // TODO: Consider checking the user agent instead.
    detectMobile() {
      return window.innerWidth < breakpoints.phone;
    },

    detectTablet() {
      return (
        window.innerWidth >= breakpoints.phone &&
        window.innerWidth < breakpoints.tablet
      );
    },

    detectDesktop() {
      return (
        window.innerWidth >= breakpoints.tablet &&
        window.innerWidth < breakpoints.desktop
      );
    },

    // TODO: Get this to work with `debounce` instead. It should only execute
    // once after the last resize event.
    handleResize: throttle(function () {
      this.isMobile = this.detectMobile();
      this.isTablet = this.detectTablet();
      this.isDesktop = this.detectDesktop();
    }),
  },
};
